import styled, { css } from "styled-components";


export const DOT_SIZE = 24;
const DARK_COLOR = '#38404d';

export const FeatureDotAnchor = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;

  ${props => props.x && css`
    margin-left: ${props.x}px;
  `}

  ${props => props.y && css`
    margin-top: ${props.y * -1}px;
  `}
`

export const FeatureDot = styled.button`
  position: absolute;
  top: -${DOT_SIZE / 2}px;
  left: -${DOT_SIZE / 2}px;
  border: 1px solid transparent;
  background: ${({theme}) => theme.thirdiary.main}cc;
  width: ${DOT_SIZE}px;
  height: ${DOT_SIZE}px;
  border-radius: 50%;
  text-align: center;
  padding: 0;
  margin: 0;
  cursor: pointer;

  ${props => props.desktoponly === true && css`
    @media ${({ theme }) => theme.device.mobile}{
      /* display: none; */
    }
    @media ${({ theme }) => theme.device.phone}{
      display: none;
    }
  `}

  svg{
    margin-top: 2px;
    fill: #fff;
  }

  &:hover{
    background: ${({theme}) => theme.thirdiary.main};
  }

  ${props => props.selected === true && css`
    background: ${({theme}) => theme.secondary.main};
    &:hover{
      background: ${({theme}) => theme.secondary.dark};
    }
  `}
`;


const WIDTH = 300;
const MIN_HEIGHT = 260;

const cutSize = 5;
const cutSize2 = 4;
const cutSize2Color = "#43413f";

export const Wrap = styled.div`
  position: absolute;
  left: 50%;
  top: 10%;
  width: ${WIDTH}px;
  margin-left: -${WIDTH / 2}px;
  background-color: ${cutSize2Color};
  padding-right: 12px;
  color: #fff;
  z-index: 1000;


  &::before {
    content: ' ';
    position: absolute;
    top: 0;
    right: -${cutSize}px;
    bottom: 0;
    border-top: ${cutSize}px solid transparent;
    border-left: ${cutSize}px solid ${cutSize2Color};
    border-bottom: ${cutSize}px solid transparent;
  }

  &::after {
    content: ' ';
    position: absolute;
    top: 0;
    left: -${cutSize}px;
    bottom: 0;
    border-top: ${cutSize}px solid transparent;
    border-right: ${cutSize}px solid ${cutSize2Color};
    border-bottom: ${cutSize}px solid transparent;
  }
`;

const angle = 4;

export const CloseButton = styled.button`
  position: absolute;
  top: 2px;
  right: -3px;
  cursor: pointer;
  padding: 0;
  margin: 0;
  border: 0;
  background: transparent;
  z-index: 2;
  font-size: 0;
  line-height: 0;
  height: 24px;
  width: 24px;
  background-color: ${cutSize2Color};

  svg{
    margin-top: 2px;
    padding: 0;
    margin: 0;
    fill: ${({theme}) => theme.secondary.main};
  }
  &:hover{
    svg{
      fill: #fff;
    }
  }
  
  &::before {
    content: ' ';
    position: absolute;
    top: 0;
    right: -${angle};
    bottom: 0;
    border-top: ${angle} solid transparent;
    border-left: ${angle} solid #ffff00;
    border-bottom: ${angle} solid transparent;
  }
  &::after {
    content: ' ';
    position: absolute;
    top: 0;
    left: -${angle};
    bottom: 0;
    border-top: ${angle} solid transparent;
    border-right: ${angle} solid #ffffff;
    border-bottom: ${angle} solid transparent;
  }
`;

export const Title = styled.div`
  position: absolute;
  bottom: 4px;
  display: inline-block;
  left: 12px;
  background-color: ${DARK_COLOR};
  line-height: normal;
  padding: 2px 8px;
  font-family: "Quantico", sans-serif;
  font-size: 15px;
  text-transform: uppercase;
  color: ${({theme}) => theme.secondary.main};
  margin-right: -12px;
`;

export const Description = styled.div`
  padding: 12px;
  text-align: left;
  font-size: 15px;
  margin-right: -12px;

`;

export const ImageFrame = styled.div`
  position: relative;
  margin-top: 2px;
  margin-left: -3px;
  margin-right: -3px;
  z-index: 1;
  display: block;
  line-height: 0;
  margin-right: -15px;


  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    border-top: ${cutSize2}px solid ${cutSize2Color};
    border-left: ${cutSize2}px solid transparent;
    border-bottom: ${cutSize2}px solid ${cutSize2Color};
    z-index: 1;
  }

  &::after {
    content: ' ';
    position: absolute;
    top: 0;
    left:0;
    bottom: 0;
    border-top: ${cutSize2}px solid ${cutSize2Color};
    border-right: ${cutSize2}px solid transparent;
    border-bottom: ${cutSize2}px solid ${cutSize2Color};
    z-index: 1;
  }
`;
